import { makeStyles } from "@material-ui/core/styles";

const useTextFieldStyle = makeStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "2px solid #2684FF !important",
    },
  },
  width100: {
    width: "100%",
  },
}));

export default useTextFieldStyle;



// WEBPACK FOOTER //
// ./src/styles/textFieldStyle.js